module.exports = __webpack_public_path__ + "img/paint-strip-black-up.3c6c888.png";